//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { InvoiceTaxDisplayItem } from './InvoiceTaxDisplayItem';
import { FamilyDisplayItem } from './FamilyDisplayItem';
import { ReportDisplayItem } from './ReportDisplayItem';
import { InvoiceStatus } from './Enums';

export class InvoiceDisplayItem extends ReportDisplayItem {
    AmountDue: number | null = null;
    AmountBalanceForward: number | null = null;
    AmountPaymentsIncluded: number | null = null;
    AmountNewCharges: number | null = null;
    AmountTaxesInNewCharges: number | null = null;
    Taxes: InvoiceTaxDisplayItem[] = [];
    Deletable: boolean = false;
    DueDate: string | null = null;
    Emailed: boolean = false;
    EmailedDate: string | null = null;
    InvoiceNumber: string | null = null;
    ReminderDate: string | null = null;
    PreferredEmailRecipientParentIDs: string[] = [];
    CanAutoPay: boolean | null = null;
    FamilyID: string | null = null;
    Family: FamilyDisplayItem | null = null;
    InvoiceStatus: InvoiceStatus = InvoiceStatus.Void;
    BalanceForward: boolean = false;
    PaymentURL: string | null = null;

    constructor(initializer?: Partial<InvoiceDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "InvoiceDisplayItem";
}
